//Replace the header id to disable Dawn's default sticky header.   
//document.getElementById('shopify-section-header').setAttribute('id', 'shopify-section-header1');

//On Scroll - enable/disable the sticky header
$(window).scroll(function (event) {
  let scroll_pos = $(window).scrollTop();
  if( scroll_pos > 200){
    $('#shopify-section-header').addClass('header-sticky');
    $('.header__heading-logo.sticky-logo').removeClass('show').addClass('hide');
    $('.header__heading-logo.sticky-text-logo').removeClass('hide').addClass('show');
    $('.mega-menu__content').css('top', '45px');
    $('.header-sticky .mega-menu__content').css('top', '21px');
    $('.mega-menu-wrapper').css('border-top', '2px solid #1f1d1b');
  }else{
    $('#shopify-section-header').removeClass('header-sticky');
    $('.header__heading-logo.sticky-text-logo').removeClass('show').addClass('hide');
    $('.header__heading-logo.sticky-logo').removeClass('hide').addClass('show');
    $('.mega-menu__content').css('top', '55px');
    $('.mega-menu-wrapper').css('border-top', 'unset');
  }
});


//Mega-menu hover functionality
const screen_width = $(window).width();
if( screen_width > 1024 ){
  $('.mega-menu').hover(function(){
      $(this).attr('open', '');
      $(this).find('.header__menu-item').attr('aria-expanded', 'true');
  },function(){
      $(this).removeAttr('open', '');
      $(this).find('.header__menu-item').attr('aria-expanded', 'false');      
  });
}

//Mobile menu close
$('#menu-drawer .mobile-nav-close').on('click', function(){
  $('header-drawer[data-breakpoint="tablet"] .menu-drawer-container').removeClass('menu-opening').removeAttr('open');
  $('header-drawer[data-breakpoint="tablet"] .header__icon').attr('aria-expanded', 'false')
  $('body').removeClass('overflow-hidden-tablet');
});

//Mobile menu drawer toggle
$('.menu-with-submenu').on('click', function(){
  $(this).find('.mega-menu-title').toggleClass('open');
  $(this).find('.submenu-drawer').toggleClass('active');
});

//Collection's Filter
$('.filter-title').on('click',function(){
  $('.title-section .filter-content').toggle();
  $('.filter-title').css('z-index','3');
});
// $(document).click(function(e){
//   e.preventDefault();
//   if(e.target.id != "filter-id") {
//    $('.filter-content').hide();
//   }  
// });

